import React from 'react';

import { StyledCard } from './Card.styles';
import { TCardProps } from './Card.types';

const Card = ({ variant = 'secondary', children, ...props }: TCardProps) => (
  <StyledCard $variant={variant} {...props}>
    {children}
  </StyledCard>
);

export default Card;
